import isClientEnv from './isClientEnv'

import subscriptionProcessingStatuses from './subscriptionProcessingStatuses'
import upgradeSubscriptionFlowSteps from './upgradeSubscriptionFlowSteps'
import upgradeSubscriptionTypes from './upgradeSubscriptionTypes'
import defaultSubscriptionPrice from './defaultSubscriptionPrice'
import subscriptionPlanTypes from './subscriptionPlanTypes'
import cosmeticsProductTypes from './cosmeticsProductTypes'
import pricesWithDiscount from './pricesWithDiscount'
import { firstMonthCoupons, discountCoupons } from './discountCoupons'
import cardUpdateCoupons from './cardUpdateCoupons'
import countdownCookies from './countdownCookies'
import analyticsEvents from './analyticsEvents'
import paymentMethods from './paymentMethods'
import requestTokens from './requestTokens'
import deliveryStates from './deliveryStates'
import specialFlowCookies from './specialFlowCookies'
import productVisibility from './productVisibility'
import localStorageNames from './localStorageNames'
import specialFlowNames from './specialFlowNames'
import facebookPixels from './facebookPixels'
import snowplowEvents from './snowplowEvents'
import deliveryTypes from './deliveryTypes'
import productsFeed from './productsFeed'
import layoutNames from './layoutNames'
import collections from './collections'
import cookieNames from './cookieNames'
import offerNames from './offerNames'
import planNames from './planNames'
import popups from './popups'

import addressVerificationOptions from './addressVerificationOptions'
import subscriptionStatuses from './subscriptionStatuses'
import addressStatuses from './addressStatuses'
import productFilterNames from './productFilterNames'
import queueItemStatuses from './queueItemStatuses'
import productTypeGroups from './productTypeGroups'
import productTypeLinks from './productTypeLinks'
import restrictedSEO from './restrictedSEO'
import resubscribeTypes from './resubscribeTypes'
import unpauseTypes from './unpauseTypes'
import authViewNames from './authViewNames'
import paymentTypes from './paymentTypes'
import mediaProps from './mediaProps'
import mediaList from './mediaList'
import features from './features'
import abTests from './abTests'
import modals from './modals'
import media from './media'

import tours from './tours'

import exceptionTags from './exceptionTags'

import testIds from './testIds'

import zodiacList from './zodiacList'


export default {
  isClientEnv,

  discountCoupons,
  firstMonthCoupons,
  cardUpdateCoupons,
  resubscribeTypes,
  unpauseTypes,

  subscriptionProcessingStatuses,
  upgradeSubscriptionFlowSteps,
  upgradeSubscriptionTypes,
  defaultSubscriptionPrice,
  subscriptionPlanTypes,
  cosmeticsProductTypes,
  pricesWithDiscount,
  countdownCookies,
  analyticsEvents,
  paymentMethods,
  requestTokens,
  deliveryStates,
  specialFlowCookies,
  productVisibility,
  localStorageNames,
  specialFlowNames,
  facebookPixels,
  snowplowEvents,
  deliveryTypes,
  productsFeed,
  collections,
  layoutNames,
  cookieNames,
  offerNames,
  planNames,
  popups,

  addressVerificationOptions,
  subscriptionStatuses,
  addressStatuses,
  productFilterNames,
  queueItemStatuses,
  productTypeGroups,
  productTypeLinks,
  restrictedSEO,
  authViewNames,
  paymentTypes,
  mediaProps,
  mediaList,
  features,
  abTests,
  modals,
  media,
  tours,

  exceptionTags,

  testIds,

  zodiacList,
}
